import React from 'react';
import { SlideContent } from '../components/canvas/SlideContent';
import { SlideFooter } from '../components/canvas/SlideFooter';
import { SlideLogo } from '../components/canvas/SlideLogo';
import { NudgeableGroup } from '../components/canvas/NudgeableGroup';

/**
 * Sidebar Accent layout — Swiss typography style.
 * Thin gradient accent bar on the left edge, content indented right.
 * Footer pinned at bottom for cross-template consistency.
 */
export function SidebarAccentLayout({ data, fontPreset, logoEnabled = true, logoUrl = null, logoSize = null, logoIsDark = false, pc }) {
  return (
    <div className="absolute inset-0 flex">
      {/* Accent sidebar */}
      <div
        className="w-[6px] h-full shrink-0"
        style={{
          background: `linear-gradient(180deg, ${pc.accent(0.80)} 0%, ${pc.accentSoft(0.60)} 100%)`,
        }}
      />

      {/* Content area */}
      <div className="flex-1 flex flex-col px-[72px] py-[72px] pb-[140px]">
        {/* Logo */}
        {logoEnabled && (
          <NudgeableGroup groupId="logo" className="mb-6">
            <SlideLogo className="h-14 w-14" style={{ color: pc.text(0.60) }} logoUrl={logoUrl} size={logoSize} isDark={logoIsDark} />
          </NudgeableGroup>
        )}

        <NudgeableGroup groupId="content" className="flex-1 flex flex-col justify-center">
          <SlideContent
            data={data}
            fontPreset={fontPreset}
            pc={pc}
            options={{
              showFooter: false,
              mutedOpacity: 0.65,
              subtleOpacity: 0.45,
            }}
          />
        </NudgeableGroup>
      </div>

      {/* Footer — pinned at bottom */}
      <div className="absolute bottom-[64px] left-[64px] right-[64px]">
        <SlideFooter data={data} pc={pc} />
      </div>
    </div>
  );
}
